import api from './api';
import type { PageResponse, ProductItem, ProductRequestData } from '../types';
import type { ProductQuery } from './productService';

export const adminProductService = {
  getAdminProducts: async ({ search, serviceId, page, size }: ProductQuery): Promise<PageResponse<ProductItem>> => {
    const searchParams: Record<string, string | number> = {};
    if (search !== undefined && search !== '') searchParams.search = search;
    if (serviceId !== undefined && serviceId !== '') searchParams.serviceId = serviceId;
    if (page !== undefined) searchParams.page = page;
    if (size !== undefined) searchParams.size = size;
    return api.get('products/admin', { searchParams }).json<PageResponse<ProductItem>>();
  },
  createProduct: async (data: ProductRequestData): Promise<ProductItem> => {
    return api.post('products', { json: data }).json<ProductItem>();
  },
  updateProduct: async (productId: string, data: ProductRequestData): Promise<ProductItem> => {
    return api.put(`products/${productId}`, { json: data }).json<ProductItem>();
  },
  deleteProduct: async (productId: string): Promise<void> => {
    await api.delete(`products/${productId}`);
  },
};
